import { useEffect, useRef } from "react";

/**
 * Works like setInterval. If delay is not a number it will cancel the execution
 * @param {Function} callback
 * @param {Number} delay
 */
const useInterval = (callback, delay) => {
  const callbackRef = useRef();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (typeof delay === "number") {
      const id = setInterval(() => callbackRef.current(), delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

export default useInterval;
